/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  ICustomCondition,
  ICustomConditionInterface,
} from "../../../../contracts/periphery/Types.sol/ICustomCondition";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "enum Operation",
        name: "operation",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "location",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "size",
        type: "uint256",
      },
      {
        internalType: "bytes12",
        name: "extra",
        type: "bytes12",
      },
    ],
    name: "check",
    outputs: [
      {
        internalType: "bool",
        name: "success",
        type: "bool",
      },
      {
        internalType: "bytes32",
        name: "reason",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

export class ICustomCondition__factory {
  static readonly abi = _abi;
  static createInterface(): ICustomConditionInterface {
    return new Interface(_abi) as ICustomConditionInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): ICustomCondition {
    return new Contract(address, _abi, runner) as unknown as ICustomCondition;
  }
}
